import { define } from "../preactement/define";
import { attributes } from "./shared-attributes";
import { ArrowIcon } from "../../Icons";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const arrowAttributes = [...attributes, 'direction'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    ariaHidden = 'true',
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(ArrowIcon, {
    ariaHidden: parseBooleanAttr(ariaHidden),
    ...otherProps
  });
};
define('ds-arrow-icon', () => Wrapper, {
  attributes: arrowAttributes
});